































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { themed, themedFill, themedFillTextColor } from "@/utils/Theme";
import { COLOR_STANDARD_WHITE, COLOR_WHITE_BACKGROUND_DARK } from "@/utils/colors";

export interface DryingInfoTable {
  rows: DryingInfoTableRow[];
}

export interface DryingInfoTableRow {
  bold?: boolean;
  allowVariableValuesWidth?: boolean;
  rowLabels: string[];
  rowValues: string[];
  colorLabels?: string[];
  colorValues?: string[];
  highlight?: boolean[];
}

@Component
export default class DryingInfoTableComponent extends Vue {
  @Prop()
  table!: DryingInfoTable;

  @Prop({ default: 2 })
  labelCols!: number;

  @Prop({ default: false })
  isForDeviceHistory!: boolean;

  @Prop({ default: false })
  highlightEntry!: boolean;

  currentWidth = window.innerWidth;

  get dynamicLabelCols() {
    return this.currentWidth < 520
      ? this.labelCols + 2
      : this.currentWidth < 760
        ? this.labelCols + 1
        : this.labelCols;
  }

  get valueCols() {
    return 12 - this.dynamicLabelCols;
  }

  get rows() {
    return this.table.rows;
  }

  /**
   * Phones and iPad mini (below 960 px) get the scrolling table; the label columns cut "Sensor3L" to
   * "Sensor…" at 768 px. The device history keeps its own list layout.
   */
  get isPhoneTable() {
    return this.$vuetify.breakpoint.smAndDown && !this.isForDeviceHistory;
  }

  /** The widest row's number of value cells ("Anfang, Ende, min, max", or one per phase), the span of a text row. */
  get phoneValueColumns() {
    const counts = this.rows
      .filter((row) => !row.allowVariableValuesWidth)
      .map((row) => row.rowValues.length);

    return Math.max(1, ...counts);
  }

  /** The pinned label column needs the card's own colour, or the values scroll visibly beneath it. */
  get phoneTableStyle() {
    return { "--label-background": themed(COLOR_STANDARD_WHITE, COLOR_WHITE_BACKGROUND_DARK) };
  }

  /**
   * A highlighted value's fill and text. In dark mode the highlight takes the palette shade with
   * dark text; before, the theme's white text sat on the pale light-mode yellow.
   */
  highlightStyle(color: string | null | undefined) {
    if (!color) {
      return { "background-color": null };
    }

    return {
      "background-color": themedFill(color),
      color: themedFillTextColor(color, ""),
    };
  }

  getRowLabelCols(rowLabels: string[]) {
    return rowLabels.length === 0
      ? this.dynamicLabelCols
      : this.dynamicLabelCols / rowLabels.length;
  }

  mounted() {
    window.addEventListener('resize', this.updateWidth);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.updateWidth);
  }

  updateWidth() {
    this.currentWidth = window.innerWidth;
  }
}
